// In Vite, environment variables must be accessed through import.meta.env
// and must be prefixed with VITE_
if (!import.meta.env.VITE_API_URL) {
  throw new Error('MissingEnv VITE_API_URL');
}

export interface ShowDetail {
  show_id: string;
  lat: number;
  lng: number;
}

export const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  aiApiUrl: import.meta.env.VITE_AI_API_URL,
  stadiaMapsApiKey: import.meta.env.VITE_STADIA_MAPS_API_KEY,
  defaultMapPosition: {
    lat: 54.6195719,
    lng: -1.0669469,
  },
  defaultMapZoom: 14,
};

export const showDetails: ShowDetail[] = [
  { show_id: 'here-test-nov-2025', lat: 50.833125, lng: -0.209668 },
  { show_id: 'brighton-festival-2021', lat: 50.82314, lng: -0.13955 },
  { show_id: 'norfolk-and-norwich-festival-2021', lat: 52.6278, lng: 1.28862 },
  { show_id: '101-outdoor-arts-2021', lat: 51.40037, lng: -1.32309 },
  { show_id: 'freedom-festival-hull-2021', lat: 53.74318, lng: -0.33671 },
  { show_id: 'sirenos-vilnius-2021', lat: 54.68458, lng: 25.29252 },
  { show_id: 'norfolk-wonder-kings-lynn-2021', lat: 52.75384, lng: 0.39345 },
  { show_id: 'norfolk-wonder-great-yarmouth-2021', lat: 52.60518, lng: 1.72927 },
  { show_id: 'norfolk-wonder-sheringham-2021', lat: 52.94345, lng: 1.21088 },
  { show_id: 'au-adelaide-2022', lat: -34.921, lng: 138.60389 },
  { show_id: 'au-melbourne-2022', lat: -37.81759, lng: 144.96868 },
  { show_id: 'lu-grand-theatre-2022', lat: 49.61753, lng: 6.12724 },
  { show_id: 'portsmouth-portsfest-2022', lat: 50.79892, lng: -1.09481 },
  { show_id: 'keswick-edenarts-2023', lat: 54.59652, lng: -3.1389 },
  { show_id: 'darlington-edenarts-2023', lat: 54.51539, lng: -1.56022 },
  { show_id: 'redcar-edenarts-2023', lat: 54.61898, lng: -1.0652 },
];

/**
 * Get map position for a given show_id
 * @param showId - The show ID to look up
 * @returns Map position with lat/lng, or default position if not found
 */
export const getMapPositionForShow = (showId: string | null | undefined): { lat: number; lng: number } => {
  if (!showId) {
    return config.defaultMapPosition;
  }
  const showDetail = showDetails.find((show) => show.show_id === showId);
  return showDetail ? { lat: showDetail.lat, lng: showDetail.lng } : config.defaultMapPosition;
};